export default __webpack_public_path__ + "static/backgroundOurBranchesLeftIllustration-0e223727cc2d8fbfdeb03a2cd39ce951.svg";